export const globalStyles = {
    palette: {
        brandPrimary: {
            main: '#263a46'
        }
    }
};
